import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import { Textarea } from '../../ui/textarea';
import { Loader2 } from 'lucide-react';

/**
 * Paste CSV → create many games in one go. Extracted from TournamentGames.js
 * in iter277.
 */
const BulkUploadGamesDialog = ({
  open,
  onOpenChange,
  tournament,
  bulkData,
  setBulkData,
  onUpload,
  submitting,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Bulk Upload Games</DialogTitle>
          <DialogDescription>
            Paste CSV data to create multiple games at once
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="bg-slate-50 p-4 rounded-lg">
            <p className="text-sm font-medium mb-2">CSV Format (include header row):</p>
            <code className="text-xs text-slate-600">
              age_category,game_date,start_time,location,opponent_team,game_type,notes<br/>
              u12,2026-07-15,10:00,Main Ground,Springfield Lions,home,Quarter final<br/>
              u12,2026-07-16,14:00,Away Stadium,Metro Hawks,away,
            </code>
          </div>

          <div>
            <Label>Paste CSV Data</Label>
            <Textarea
              value={bulkData}
              onChange={(e) => setBulkData(e.target.value)}
              placeholder="Paste your CSV data here..."
              className="font-mono text-sm"
              rows={10}
              data-testid="bulk-upload-textarea"
            />
          </div>

          <div className="text-sm text-slate-500">
            <p>• Valid age categories: {tournament?.age_categories?.join(', ')}</p>
            <p>• Game dates must be between {tournament?.start_date} and {tournament?.end_date}</p>
            <p>• Game type must be "home" or "away"</p>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onUpload} disabled={submitting} data-testid="upload-games-btn">
            {submitting && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
            Upload Games
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BulkUploadGamesDialog;
